export default "__VITE_ASSET__BsdNbVRW__"